import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';
import type { PlaybackUrlItem } from '@/types/video.types';

interface PlaybackUrlData {
  items: PlaybackUrlItem[];
}

export async function getPlaybackUrls(videoInterviewId: string): Promise<PlaybackUrlItem[]> {
  const response = await apiClient.get<ApiResponse<PlaybackUrlData>>(
    `/video/interviews/${videoInterviewId}/playback-url`,
  );
  return response.data.items;
}
